export function isSameDay(_dt1: Date, _dt2?: Date | null) {
  const secondDate = _dt2 ? _dt2 : new Date();
  return (
    _dt1.getFullYear() === secondDate.getFullYear() &&
    _dt1.getMonth() === secondDate.getMonth() &&
    _dt1.getDate() === secondDate.getDate()
  );
}

export const formatTimeAgo = (date: Date) => {
  const now = new Date();
  const diff = now.getTime() - date.getTime();
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor(diff / (1000 * 60));

  if (days > 0) return `${days}d ago`;
  if (hours > 0) return `${hours}h ago`;
  if (minutes > 0) return `${minutes}m ago`;
  return 'Just now';
};
